import React, { useEffect } from 'react';
import LandingNavbar from '../components/Landing/LandingNavbar';
import LandingFooter from '../components/Landing/LandingFooter';
import './landing.css';

const TestimonialsPage: React.FC = () => {
    useEffect(() => {
        const observerOptions = {
            threshold: 0.1,
            rootMargin: '0px 0px -50px 0px'
        };

        const observer = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('animate-in');
                }
            });
        }, observerOptions);

        document.querySelectorAll('.testimonial-card').forEach(el => {
            observer.observe(el);
        });

        return () => observer.disconnect();
    }, []);

    return (
        <div className="main-landing-admin">
            <LandingNavbar />

            <section className="testimonials-page hero-sub">
                <div className="container">
                    <div className="hero-sub-content">
                        <h1 className="section-title gradient-text">What Our <span>Clients Say</span></h1>
                        <p className="hero-description">
                            Join hundreds of happy organizations that have transformed their operations with Asknow.
                        </p>
                    </div>

                    <div className="testimonials-grid">
                        <div className="testimonial-card">
                            <div className="testimonial-content">
                                <i className="fas fa-quote-left quote-icon"></i>
                                <p>"Asknow transformed our business operations completely. The predictive analytics helped us increase efficiency by 40% within the first six months. Their support is unparalleled."</p>
                            </div>
                            <div className="testimonial-author">
                                <div className="author-avatar">
                                    <i className="fas fa-user"></i>
                                </div>
                                <div className="author-info">
                                    <h4>Sarah Johnson</h4>
                                    <p>CEO, TechCorp</p>
                                </div>
                            </div>
                        </div>

                        <div className="testimonial-card">
                            <div className="testimonial-content">
                                <i className="fas fa-quote-left quote-icon"></i>
                                <p>"The machine learning models they built for us are incredibly accurate. Our customer satisfaction scores improved dramatically as we could predict needs before they even arose."</p>
                            </div>
                            <div className="testimonial-author">
                                <div className="author-avatar">
                                    <i className="fas fa-user-circle"></i>
                                </div>
                                <div className="author-info">
                                    <h4>Michael Chen</h4>
                                    <p>CTO, InnovateLab</p>
                                </div>
                            </div>
                        </div>

                        <div className="testimonial-card">
                            <div className="testimonial-content">
                                <i className="fas fa-quote-left quote-icon"></i>
                                <p>"Outstanding service and support. The AI implementation was smooth and delivered results beyond our expectations. Asknow is not just a tool, but a strategic partner."</p>
                            </div>
                            <div className="testimonial-author">
                                <div className="author-avatar">
                                    <i className="fas fa-user-tie"></i>
                                </div>
                                <div className="author-info">
                                    <h4>Emily Rodriguez</h4>
                                    <p>VP Operations, DataFlow</p>
                                </div>
                            </div>
                        </div>

                        <div className="testimonial-card">
                            <div className="testimonial-content">
                                <i className="fas fa-quote-left quote-icon"></i>
                                <p>"We've tried several AI platforms, but Asknow's ease of integration and the depth of their NLP understanding is simply on another level. Highly recommended."</p>
                            </div>
                            <div className="testimonial-author">
                                <div className="author-avatar">
                                    <i className="fas fa-user-ninja"></i>
                                </div>
                                <div className="author-info">
                                    <h4>David Wilson</h4>
                                    <p>Director of AI, GlobalLink</p>
                                </div>
                            </div>
                        </div>

                        <div className="testimonial-card">
                            <div className="testimonial-content">
                                <i className="fas fa-quote-left quote-icon"></i>
                                <p>"The security features and compliance standards provided by Asknow gave us the confidence to implement AI in our highly regulated financial environment."</p>
                            </div>
                            <div className="testimonial-author">
                                <div className="author-avatar">
                                    <i className="fas fa-user-shield"></i>
                                </div>
                                <div className="author-info">
                                    <h4>Amanda Lee</h4>
                                    <p>Compliance Officer, SecureBank</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <LandingFooter />
        </div>
    );
};

export default TestimonialsPage;
